import { render, staticRenderFns } from "./newselectphonenum.vue?vue&type=template&id=0b312bab&scoped=true"
import script from "./newselectphonenum.vue?vue&type=script&lang=js"
export * from "./newselectphonenum.vue?vue&type=script&lang=js"
import style0 from "./newselectphonenum.vue?vue&type=style&index=0&id=0b312bab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b312bab",
  null
  
)

export default component.exports